"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["EUR"] = "eur";
})(Currency || (exports.Currency = Currency = {}));
//# sourceMappingURL=Currency.js.map